export default {
    props: {
        currentStep: {
            type: Number,
            default: 1
        },
        totalSteps: {
            type: Number,
            default: 8
        },
    },
}